import { useSelector } from 'react-redux'

export const getActiveCommunity = (user, activeCommunityId) => {
  const communities = user?.communities || []

  if (communities.length === 0) {
    return null
  }

  return communities.find((community) => community.id === activeCommunityId) || communities[0]
}

export const getActiveCommunityId = (user, activeCommunityId) => getActiveCommunity(user, activeCommunityId)?.id || null

export const postedToCommunityMessage = (user, activeCommunityId, t) => {
  const activeCommunity = getActiveCommunity(user, activeCommunityId)

  if ((user?.communities || []).length < 2 || !activeCommunity) {
    return ''
  }

  return t('common.postedToCommunity', { community: activeCommunity.name })
}

export const requiresCommunityChoice = (user, activeCommunityId) => {
  const communities = user?.communities || []

  return communities.length > 1 && !communities.some((community) => community.id === activeCommunityId)
}

export const useActiveCommunity = () => {
  const user = useSelector((state) => state.user.current_user)
  const activeCommunityId = useSelector((state) => state.user.active_community_id)

  return getActiveCommunity(user, activeCommunityId)
}

export const useActiveCommunityId = () => useActiveCommunity()?.id || null
